var map = {
	"./books.png": "1065",
	"./chart.png": "bb92",
	"./island.png": "c720",
	"./left-hand.png": "8fa0",
	"./map.png": "5e3d",
	"./painting.png": "8961",
	"./rainbow.png": "6a7b",
	"./right-hand.png": "2e30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "718c";